import api, { adminApiPrefix } from './Api';
import {
  MenuItem,
  menuItemFromResponse,
  menuItemToUpsertRequest,
} from '../interfaces/Menu/MenuItem';
import {
  MenuItemOrder,
  menuItemOrderToUpsertRequest,
} from '../interfaces/Menu/MenuItemOrder';

const menuItemAdminApiPrefix = `${adminApiPrefix}/menu-items`;

export const createMenuItem = async (menuItem: MenuItem): Promise<MenuItem> => {
  const response = await api.post(
    menuItemAdminApiPrefix,
    menuItemToUpsertRequest(menuItem),
  );

  return menuItemFromResponse(response.data?.data);
};

export const getMenuItems = async (menuID: number): Promise<MenuItem[]> => {
  const response = await api.get(`${menuItemAdminApiPrefix}/${menuID}`);

  return (response.data?.data ?? []).map((menuItem: any) =>
    menuItemFromResponse(menuItem),
  );
};

export const updateMenuItem = async (menuItem: MenuItem): Promise<MenuItem> => {
  const response = await api.put(
    `${menuItemAdminApiPrefix}/${menuItem.id}`,
    menuItemToUpsertRequest(menuItem),
  );

  return menuItemFromResponse(response.data?.data);
};

export const updateMenuItemOrders = async (
  updates: MenuItemOrder[],
): Promise<void> =>
  api.post(`${menuItemAdminApiPrefix}/order`, {
    updates: updates.map((u) => menuItemOrderToUpsertRequest(u)),
  });

export const deleteMenuItem = async (id: number): Promise<void> =>
  api.delete(`${menuItemAdminApiPrefix}/${id}`);
